import React, { FC } from 'react';
import { useIconColor } from '../../../hooks/useIconColor';

interface IconLightBulbProps {
  className?: string;
}

const IconLightBulb: FC<IconLightBulbProps> = (props: IconLightBulbProps) => {
  const { className } = props;
  const { iconColor } = useIconColor();

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect x="12" y="26" width="8" height="2" rx="1" fill={iconColor} />
      <path
        d="M13 29H19C19 30.1046 18.1046 31 17 31H15C13.8954 31 13 30.1046 13 29Z"
        fill={iconColor}
      />
      <path
        d="M16 12C18.4991 12 20.5836 13.9104 20.801 16.4001L20.8217 16.6377C20.9209 17.7738 20.6461 18.9112 20.0392 19.8767L19.3693 20.9424C18.7839 21.8737 18.4091 22.9172 18.2659 24H13.7341C13.5909 22.9172 13.2161 21.8737 12.6307 20.9424L11.9608 19.8767C11.3539 18.9112 11.0791 17.7738 11.1783 16.6377L11.199 16.4001C11.4164 13.9104 13.5009 12 16 12Z"
        stroke={iconColor}
        fill="none"
        strokeWidth="2"
      />
      <rect x="15" y="2" width="2" height="7" fill={iconColor} />
      <rect
        x="22.0774"
        y="4.134"
        width="2"
        height="6.16204"
        transform="rotate(30 22.0774 4.134)"
        fill={iconColor}
      />
      <rect
        x="25.7435"
        y="9"
        width="2"
        height="4.32262"
        transform="rotate(60 25.7435 9)"
        fill={iconColor}
      />
      <rect
        width="2"
        height="6.16204"
        transform="matrix(-0.866025 0.5 0.5 0.866025 9.66614 4.134)"
        fill={iconColor}
      />
      <rect
        width="2"
        height="4.32262"
        transform="matrix(-0.5 0.866025 0.866025 0.5 6 9)"
        fill={iconColor}
      />
    </svg>
  );
};

export default IconLightBulb;
